import { Container } from "@mui/material";
import Layout from "../../components/Layout";
import { useEffect, useState } from "react";
import { UserServiceInternal } from "../../services/user.service";
import { CorrectionalFacilityUserForm } from "../../components/CorrectionalFacilityUser/CorrectionalFacilityUserForm";
import { CorrectionalFacilityUserDto, CorrectionalFacilityUserResponse } from "../../models/correctionalFacilityUserDto";

function NewCorrectionalFacilityUser() {
  const [facilitUserDetail, setfacilityUserDetail] = useState<CorrectionalFacilityUserDto>(new CorrectionalFacilityUserDto());
  const urlSearchParams = new URLSearchParams(window.location.search);
  const id = urlSearchParams.get("id");


  const getUserById = async () => {
    try {
      const response = await UserServiceInternal.getUserById(Number(id));
      const facilityUserDetailResponse: CorrectionalFacilityUserResponse = response.data.data;
      setfacilityUserDetail(facilityUserDetailResponse ? CorrectionalFacilityUserDto.fromResponse(facilityUserDetailResponse) : new CorrectionalFacilityUserDto());
    } catch (exception) {
      console.log(exception);
    }
  }

  useEffect(() => {
    if (id) {
      getUserById();
    }
    return () => {
      setfacilityUserDetail(facilitUserDetail);
    }
  }, [id]);
  return (
    <Layout>
      <Container className="p-5">
        <CorrectionalFacilityUserForm facilityUserDetail={facilitUserDetail} />
      </Container>
    </Layout>
  )
}
export default NewCorrectionalFacilityUser;